import { BROADCAST_LISTING_FIELDS } from './broadcastListing.js';
import { BROADCAST_SIDE_MENU_FIELDS } from './broadcastSideMenu.js';
export const SCREEN_FILE_EXTRA_FIELDS = {
    broadcast: [...BROADCAST_LISTING_FIELDS, ...BROADCAST_SIDE_MENU_FIELDS],
};
//# sourceMappingURL=catalog-screen-extras.js.map